import { useQuery } from 'react-query';

import { useInfiniteQuery } from 'core/hooks';
import { GetOneResult, IRequestPayload } from 'core/types';
import { taxonomyService } from 'taxonomy/services';
import { ITaxonomyGroup } from 'taxonomy/types';

export const useGetTaxonomyGroups = (
  requestPayload?: IRequestPayload,
  options: { enabled?: boolean; fetchAllPages?: boolean } = {}
) =>
  useInfiniteQuery<ITaxonomyGroup>(
    taxonomyService.getTaxonomyGroups,
    'taxonomyGroups',
    requestPayload,
    options
  );

export const useGetTaxonomyGroup = (
  criteria: Record<string, unknown>,
  enabled = true
): GetOneResult<ITaxonomyGroup> => {
  const requestPayload = {
    filters: criteria,
  };

  const { data, isLoading, isFetching, isError } = useQuery(
    ['taxonomyGroup', criteria],
    ({ signal }) => taxonomyService.getTaxonomyGroups(requestPayload, signal),
    {
      keepPreviousData: false,
      enabled,
    }
  );

  return {
    record: data?.records?.[0] ?? null,
    isLoading,
    isFetching,
    isError,
  };
};
